export default "__VITE_ASSET__123f0f96__"